<core-layout-error-not-found [hidden]="status != STATUS_NOT_FOUND"></core-layout-error-not-found>

<core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading>

<core-version-shares
    *ngIf="versionShareBubbles != null && versionShareBubbles.length > 0"
    [versionShareBubbles]="versionShareBubbles"
    [menu]="menu"
    (menuClick)="onMenuItemClick($event)"
></core-version-shares>
